export default __webpack_public_path__ + "static/sam42_purchase-b0af621112738a2fd63736d3c2f44d3c.jpg";